import { FiInfo, FiImage, FiFile, FiFileText } from "../../assets/icons/vander";

export const InformedConsent = ({ eventFiles = [] }) => {
  return (
    <div className="space-y-3">
      {eventFiles.map((file) => {
        const { mimeType, url, fileName } = file;

        let icon = <FiFile className="me-2" />;
        let label = "Archivo";

        if (mimeType.includes("image")) {
          icon = <FiImage className="me-2 text-blue-500" />;
          label = "Imagen";
        } else if (mimeType === "application/pdf") {
          icon = <FiFileText className="me-2 text-red-500" />;
          label = "PDF";
        }

        return (
          <div key={fileName} className="flex items-center space-x-2">
            {icon}
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm underline hover:text-blue-600"
            >
              {label}: {fileName}
            </a>
          </div>
        );
      })}
    </div>
  );
};
